import { useRef, useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';

import { Button, ZekTecLogo } from './ui';

import { useAuth } from '../contexts/AuthContext';
import { useT } from '../i18n/messages';

const navigation = [
  { href: '/', label: 'billing.nav.overview' },
  { href: '/review-center', label: 'billing.nav.reviewCenter' },
  { href: '/applications', label: 'billing.nav.applications' },
  { href: '/providers', label: 'billing.nav.providers' },
  { href: '/products', label: 'billing.nav.products' },
  { href: '/customers', label: 'billing.nav.customers' },
  { href: '/subscriptions', label: 'billing.nav.subscriptions' },
  { href: '/events', label: 'billing.nav.events' },
  { href: '/deliveries', label: 'billing.nav.deliveries' },
  { href: '/reconciliation', label: 'billing.nav.reconciliation' },
  { href: '/replays', label: 'billing.nav.replays' },
  { href: '/audit-logs', label: 'billing.nav.auditLogs' },
  { href: '/portal-sessions', label: 'billing.nav.portalSessions' },
  { href: '/subscription-previews', label: 'billing.nav.subscriptionPreviews' },
];

export function Layout() {
  const [navigationOpen, setNavigationOpen] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);
  const { logout } = useAuth();
  const t = useT();

  return (
    <div className="shell" data-testid="billing-dashboard-shell">
      <aside
        className="sidebar"
        onKeyDown={(event) => {
          if (event.key === 'Escape' && navigationOpen) {
            setNavigationOpen(false);
            toggleRef.current?.focus();
          }
        }}
      >
        <div className="brand-lockup">
          <ZekTecLogo />
        </div>
        <button
          type="button"
          className="ghost-button navigation-toggle"
          ref={toggleRef}
          aria-controls="billing-navigation"
          aria-expanded={navigationOpen}
          onClick={() => setNavigationOpen((open) => !open)}
        >
          {t(navigationOpen ? 'billing.nav.close' : 'billing.nav.open')}
        </button>
        <div id="billing-navigation" className={`sidebar-navigation${navigationOpen ? ' is-open' : ''}`}>
          <nav className="nav" aria-label={t('billing.column.primary')}>
            {navigation.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                onClick={() => {
                  setNavigationOpen(false);
                  toggleRef.current?.focus();
                }}
                end={item.href === '/'}
                className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
              >
                <span className="nav-link-label">{t(item.label)}</span>
              </NavLink>
            ))}
          </nav>
          <Button className="sidebar-action" onClick={logout} type="button" variant="secondary">
            {t('billing.auth.logout')}
          </Button>
        </div>
      </aside>
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}
